import { appNavigate } from './appNavigate';

/**
 * Same as appNavigate but replaces the current history entry — keeps the scan
 * wizard feeling like one surface instead of stacking many full navigations.
 */
export function appReplaceNavigate(url: string): void {
  window.history.replaceState({}, '', url);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export { appNavigate };
